import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Resource } from '../../stores/ResourceStore';
import withEditMode from '../../components/hocs/withEditMode.react';
import { ResourceTypeSelect, ResourceNameInput, ResourceInfoInput, EditResourceActionButtons } from './EditResourceComponents.react';

const EditResourceForm = (
  { addTopBorder, currentEditedResource, editFromFormField, exitEditMode },
) => (
  <div className={classNames({ 'resource-listing': true, 'resource-listing-border-top': addTopBorder })}>
    <div className='credential-leftside'>
      <ResourceTypeSelect
        resource={currentEditedResource}
        onResourceTypeChange={editFromFormField('resourceType')}
      />
      <ResourceNameInput
        resource={currentEditedResource}
        onUpdateResourceName={editFromFormField('resourceName')}
      />
      <ResourceInfoInput
        resource={currentEditedResource}
        onUpdateResourceInfo={editFromFormField('resourceInfo')}
      />
    </div>
    <EditResourceActionButtons
      resource={currentEditedResource}
      exitEditMode={exitEditMode}
    />
  </div>
);

EditResourceForm.propTypes = {
  addTopBorder: PropTypes.bool,
  currentEditedResource: PropTypes.instanceOf(Resource),
  editFromFormField: PropTypes.func,
  exitEditMode: PropTypes.func,
};

export default withEditMode('resource')(EditResourceForm);
